<template>
    <div class="content-list px-2 py-2">
        <CampaignListItem
            :campaign="campaign"
            :key="index"
            @clickCampaign="clickCampaign($event)"
            v-for="(campaign, index) of campaigns"
        />
        <div
            v-if="isShowSeeMore"
            class="btn-see-more text-center"
            @click="clickSeeMore()"
        >
            See more ...
        </div>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin";
//component
import CampaignListItem from "./CampaignListItem.vue";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";

export default {
    name: "CampaignList",
    props: {
        modalController: Object,
        initListConfig: Object,
        initFilterConfig: Object
    },
    components: {
        CampaignListItem
    },
    mixins: [AccountMixin],
    data: function() {
        return {
            listConfig: {},
            filterConfig: {},
            campaigns: [],
            isShowSeeMore: true
        };
    },
    created: function() {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;
    },
    mounted: function() {
        this.getList();
    },
    methods: {
        clickCampaign: function(campaign) {
            //GA
            var path = "/campaign/" + campaign.id;
            this.$router.push(path);
        },
        clickSeeMore: function() {
            this.getList();
        },
        getList: function() {
            if (!this.listConfig.strConfigList) return;
            var token = this.getToken();
            var config = this.listConfig;
            var filter = this.filterConfig;
            this.showLoading();
            BzbsCampaign.apiGetCampaign(token, config, filter).subscribe(
                campaigns => {
                    this.listConfig.intSkip += config.defaultTopAmount;
                    //check is there are more campaign.
                    if (campaigns.length < config.defaultTopAmount) {
                        // this.listConfig.isSeeMoreEnable = false;
                        this.isShowSeeMore = false;
                    }

                    //reinitialize list if no skip.
                    if (config.intSkip == config.defaultTopAmount)
                        this.campaigns = [];
                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }
                    this.isLoaded = true;
                    this.hideLoading();
                },
                err => {
                    this.isLoaded = true;
                    this.hideLoading();
                    console.log(err);
                }
            );
        },
        hideLoading: function() {
            this.modalController.loadingModal.hide();
        },
        showLoading: function() {
            this.modalController.loadingModal.show();
        }
    }
};
</script>
